
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_1fzf0_189",
  "refresh": "awsui_refresh_1r9lg_1fzf0_189",
  "animating": "awsui_animating_1r9lg_1fzf0_203",
  "preference-icon--layout-border": "awsui_preference-icon--layout-border_1r9lg_1fzf0_226",
  "preference-icon--layout-background": "awsui_preference-icon--layout-background_1r9lg_1fzf0_230",
  "preference-icon--layout-header": "awsui_preference-icon--layout-header_1r9lg_1fzf0_233",
  "preference-icon--border": "awsui_preference-icon--border_1r9lg_1fzf0_236",
  "preference-icon--primary-button": "awsui_preference-icon--primary-button_1r9lg_1fzf0_240",
  "preference-icon--secondary": "awsui_preference-icon--secondary_1r9lg_1fzf0_243",
  "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_1r9lg_1fzf0_246",
  "preference-icon--separator": "awsui_preference-icon--separator_1r9lg_1fzf0_249",
  "preference-icon--focus-text": "awsui_preference-icon--focus-text_1r9lg_1fzf0_252",
  "preference-icon-refresh--layout-top": "awsui_preference-icon-refresh--layout-top_1r9lg_1fzf0_256",
  "preference-icon-refresh--layout-main": "awsui_preference-icon-refresh--layout-main_1r9lg_1fzf0_259",
  "preference-icon-refresh--primary": "awsui_preference-icon-refresh--primary_1r9lg_1fzf0_262",
  "preference-icon-refresh--disabled": "awsui_preference-icon-refresh--disabled_1r9lg_1fzf0_265",
  "preference-icon-refresh--column-header": "awsui_preference-icon-refresh--column-header_1r9lg_1fzf0_268",
  "preference-icon-refresh--window": "awsui_preference-icon-refresh--window_1r9lg_1fzf0_271",
  "preference-icon-refresh--secondary": "awsui_preference-icon-refresh--secondary_1r9lg_1fzf0_275",
  "preference-icon-refresh--default": "awsui_preference-icon-refresh--default_1r9lg_1fzf0_278",
  "preference-icon-refresh--separator": "awsui_preference-icon-refresh--separator_1r9lg_1fzf0_281",
  "preference-icon-refresh--input-default": "awsui_preference-icon-refresh--input-default_1r9lg_1fzf0_284",
  "preference-icon-refresh--heading": "awsui_preference-icon-refresh--heading_1r9lg_1fzf0_287",
  "root": "awsui_root_1r9lg_1fzf0_291",
  "preferences-button": "awsui_preferences-button_1r9lg_1fzf0_304",
  "close-button": "awsui_close-button_1r9lg_1fzf0_308",
  "drawer-closed": "awsui_drawer-closed_1r9lg_1fzf0_320",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_1fzf0_325",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_1fzf0_345",
  "position-bottom": "awsui_position-bottom_1r9lg_1fzf0_354",
  "position-side": "awsui_position-side_1r9lg_1fzf0_381",
  "slider": "awsui_slider_1r9lg_1fzf0_387",
  "slider-side": "awsui_slider-side_1r9lg_1fzf0_416",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_1fzf0_421",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_1fzf0_432",
  "open-button": "awsui_open-button_1r9lg_1fzf0_443",
  "open-button-side": "awsui_open-button-side_1r9lg_1fzf0_447",
  "slider-icon": "awsui_slider-icon_1r9lg_1fzf0_454",
  "slider-icon-bottom": "awsui_slider-icon-bottom_1r9lg_1fzf0_460",
  "slider-icon-side": "awsui_slider-icon-side_1r9lg_1fzf0_463",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_1fzf0_467",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_1fzf0_477",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_1fzf0_480",
  "content-bottom": "awsui_content-bottom_1r9lg_1fzf0_488",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_1fzf0_501",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_1fzf0_506",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_1fzf0_510",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_1fzf0_514",
  "content-side": "awsui_content-side_1r9lg_1fzf0_519",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_1fzf0_530",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_1fzf0_534",
  "header": "awsui_header_1r9lg_1fzf0_539",
  "header-text": "awsui_header-text_1r9lg_1fzf0_548",
  "header-actions": "awsui_header-actions_1r9lg_1fzf0_559",
  "divider": "awsui_divider_1r9lg_1fzf0_567"
};
  